/**
 * Fuel price + transaction intake block for Control Centre Fuel tab.
 * Collapsible; expanded by default so managers see intake first.
 */

import { useState } from 'react';
import { ChevronDown, ChevronRight } from 'lucide-react';
import FuelWeeklyPricePanel from './FuelWeeklyPricePanel';
import FuelPriceListPanel from './FuelPriceListPanel';
import FuelTransactionsUploadPanel from './FuelTransactionsUploadPanel';
import { Button } from '../ui/button';

interface FuelDataIntakeSectionProps {
  useMockData?: boolean;
  onTransactionsUploaded?: () => void;
  onPriceSaved?: () => void;
}

export default function FuelDataIntakeSection({
  useMockData = false,
  onTransactionsUploaded,
  onPriceSaved,
}: FuelDataIntakeSectionProps) {
  const [open, setOpen] = useState(true);

  return (
    <section className="space-y-3" aria-label="Fuel price and transaction data">
      <Button
        variant="ghost"
        size="sm"
        type="button"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
        className="w-full h-auto justify-start text-left group"
      >
        {open ? (
          <ChevronDown className="w-3.5 h-3.5 text-muted-foreground shrink-0" aria-hidden />
        ) : (
          <ChevronRight className="w-3.5 h-3.5 text-muted-foreground shrink-0" aria-hidden />
        )}
        <h4 className="text-xs font-bold uppercase tracking-wider text-muted-foreground group-hover:text-foreground">
          Fuel price &amp; transaction data
        </h4>
      </Button>
      {open && (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 items-stretch">
          <div className="min-w-0 h-full">
            <FuelWeeklyPricePanel useMockData={useMockData} onSaved={onPriceSaved} />
          </div>
          <div className="min-w-0 h-full">
            <FuelTransactionsUploadPanel
              useMockData={useMockData}
              onUploaded={onTransactionsUploaded}
            />
          </div>
          <div className="min-w-0 md:col-span-2">
            <FuelPriceListPanel useMockData={useMockData} onSaved={onPriceSaved} />
          </div>
        </div>
      )}
    </section>
  );
}
